<div class="mb-24">
  <div class="title title--big">Редактирование компании</div>
</div>

<app-companies-create-edit-widget></app-companies-create-edit-widget>
